import React, { useRef } from "react";
import { Line, Circle } from "react-konva";

const MastColumnAsym = ({ lanterns, position, props, colorList, luminaires, endPointSize }) => {
  const lineRefs = useRef([]);

  if (!props.polarInfo || !Array.isArray(props.polarInfo)) {
    console.log("Missing or invalid polarInfo");
    return null;
  }

  return lanterns.map((lantern, idx) => {
    const polarEntry = props.polarInfo.find(p => p?.luminaireId === lantern.luminaireId);

    if (!polarEntry || !polarEntry.polarData) {
      console.log("No polar data found for luminaireId", lantern.luminaireId, props.polarInfo);
      return null;
    }
    else {
      console.log("Polar data found for luminaireId", lantern.luminaireId, props.polarInfo);
    }

    const polarData = polarEntry.polarData;

    let peakValue = -Infinity;
    let peakIndex = -1;

    for (const [_, values] of Object.entries(polarData)) {
      for (let j = 0; j < values.length; j++) {
        if (values[j] > peakValue) {
          peakValue = values[j];
          peakIndex = j;
        }
      }
    }

    const height = props.column.values.height;
    const thetaDegrees = peakIndex;
    const thetaRad = (thetaDegrees * Math.PI) / 180.0;
    const beamLength = height * Math.tan(thetaRad) * props.gridScaleX;
    console.log("Beam length for id", idx, lantern.luminaireId, beamLength)

    if (!lineRefs.current[idx]) lineRefs.current[idx] = React.createRef();
    const lineRef = lineRefs.current[idx];

    const angleRad = ((lantern.positionAngle - 90) * Math.PI) / 180;

    const tipX = position.x + beamLength * Math.cos(angleRad);
    const tipY = position.y + beamLength * Math.sin(angleRad);

    const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
    const resolvedColor =
      luminaireIndex !== -1 && colorList[luminaireIndex]
        ? colorList[luminaireIndex]
        : "lightgray";

    return (
      <React.Fragment key={idx}>
        <Line
          ref={lineRef}
          points={[position.x, position.y, tipX, tipY]}
          stroke={resolvedColor === "#FFA500 " ? "orange" : resolvedColor}
          strokeWidth={endPointSize / 5}
        />
        <Circle
          x={tipX}
          y={tipY}
          radius={endPointSize / 2}
          fill={resolvedColor === "#FFA500 " ? "orange" : resolvedColor}
          draggable={props.selected}
          onDragMove={(e) => {
            const { x: dragX, y: dragY } = e.target.position();
            const dx = dragX - position.x;
            const dy = dragY - position.y;

            const angleDeg = (Math.atan2(dy, dx) * 180) / Math.PI;
            const adjustedAngle = angleDeg + 90;

            const angleRad = ((adjustedAngle - 90) * Math.PI) / 180;
            const fixedTipX = position.x + beamLength * Math.cos(angleRad);
            const fixedTipY = position.y + beamLength * Math.sin(angleRad);

            if (lineRef.current) {
              lineRef.current.points([position.x, position.y, fixedTipX, fixedTipY]);
              lineRef.current.getLayer().batchDraw();
            }

            props.updateLanternBeamEndpoint({
              beamEndPoint: { x: fixedTipX, y: fixedTipY },
              beamLength,
              positionAngle: adjustedAngle,
              lanternIndex: idx,
              columnIndex: props.i,
            });

            e.target.position({ x: fixedTipX, y: fixedTipY });
          }}
          onDragEnd={() => {
            props.doAreaCalc();
          }}
        />
      </React.Fragment>
    );
  });
};

export default MastColumnAsym;
